import { render } from "./About.vue?vue&type=template&id=69afd07c&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=69afd07c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69afd07c"

export default script